/**
 * File navigation.js.
 *
 * Handles toggling the navigation menu for small screens and enables TAB key
 * navigation support for dropdown menus.
 */
( function() {
	var container, button, menu, links, i, len;

	container = document.getElementById( 'site-navigation' );
	if ( ! container ) {
		return;
	}

	button = container.getElementsByTagName( 'button' )[0];
	if ( 'undefined' === typeof button ) {
		return;
	}

	menu = container.getElementsByTagName( 'ul' )[0];

	// Hide menu toggle button if menu is empty and return early.
	if ( 'undefined' === typeof menu ) {
		button.style.display = 'none';
		return;
	}

	menu.setAttribute( 'aria-expanded', 'false' );
	if ( -1 === menu.className.indexOf( 'nav-menu' ) ) {
		menu.className += ' nav-menu';
	}

	button.onclick = function() {
		if ( -1 !== container.className.indexOf( 'toggled' ) ) {
			container.className = container.className.replace( ' toggled', '' );
			button.setAttribute( 'aria-expanded', 'false' );
			menu.setAttribute( 'aria-expanded', 'false' );
		} else {
			container.className += ' toggled';
			button.setAttribute( 'aria-expanded', 'true' );
			menu.setAttribute( 'aria-expanded', 'true' );
		}
	};

	// Get all the link elements within the menu.
	links    = menu.getElementsByTagName( 'a' );

	// Each time a menu link is focused or blurred, toggle focus.
	for ( i = 0, len = links.length; i < len; i++ ) {
		links[i].addEventListener( 'focus', toggleFocus, true );
		links[i].addEventListener( 'blur', toggleFocus, true );
	}

	/**
	 * Sets or removes .focus class on an element.
	 */
	function toggleFocus() {
		var self = this;

		// Move up through the ancestors of the current link until we hit .nav-menu.
		while ( -1 === self.className.indexOf( 'nav-menu' ) ) {

			// On li elements toggle the class .focus.
			if ( 'li' === self.tagName.toLowerCase() ) {
				if ( -1 !== self.className.indexOf( 'focus' ) ) {
					self.className = self.className.replace( ' focus', '' );
				} else {
					self.className += ' focus';
				}
			}

			self = self.parentElement;
		}
	}

	/**
	 * Toggles `focus` class to allow submenu access on tablets.
	 */
	( function( container ) {
		var touchStartFn, i,
			parentLink = container.querySelectorAll( '.menu-item-has-children > a, .page_item_has_children > a' );

		if ( 'ontouchstart' in window ) {
			touchStartFn = function( e ) {
				var menuItem = this.parentNode, i;

				if ( ! menuItem.classList.contains( 'focus' ) ) {
					e.preventDefault();
					for ( i = 0; i < menuItem.parentNode.children.length; ++i ) {
						if ( menuItem === menuItem.parentNode.children[i] ) {
							continue;
						}
						menuItem.parentNode.children[i].classList.remove( 'focus' );
					}
					menuItem.classList.add( 'focus' );
				} else {
					menuItem.classList.remove( 'focus' );
				}
			};

			for ( i = 0; i < parentLink.length; ++i ) {
				parentLink[i].addEventListener( 'touchstart', touchStartFn, false );
			}
		}
	}( container ) );
	

} )();

/**
 * Menu backdrop triggering
 * @returns
 */
(function(){
	
	jQuery(".menu-parts li>a").hover(function(e){
		var container=jQuery(e.target).parentsUntil('.menu-container');
		var backdrop = jQuery(container[container.length-1]).find('.menu-backdrop');
		if (backdrop.hasClass('active')){
			backdrop.removeClass('active');
		}else{
			backdrop.addClass('active');
		}
	});
})();



(function() {
	
jQuery('.dropdown-toggle').dropdown();

}());
/*
 * 
 * Toolbox triggering
 * 
 * */

(function() {
	toolboxTrigger = document.querySelectorAll( 'a.toolbox-trigger' );
	toolboxMenu = document.querySelectorAll( '.toolbox .widget_nav_menu' );
	
	if (toolboxTrigger.length>0 && toolboxMenu.length>0){
		toolboxTrigger[0].addEventListener("click", function(){
			toolbox = document.querySelectorAll( '.toolbox' );
			if (toolbox[0].style.right =='0px'){
				toolbox[0].style.right = '-'+toolboxMenu[0].offsetWidth+'px';
			}else{
				toolbox[0].style.right ='0px';
			}	
		});
	}
	
}());

/*
 * 
 * News triggering
 * 
 * */

(function($) {

	newsTrigger = document.querySelectorAll( 'a.news_links' );	
	jQuery('.news-home-loading').hide();
	
	jQuery(newsTrigger).click(function(){
		var postId=0;
		if (jQuery(this).hasClass('left')){
			postId = jQuery('#next-news').val();
		}else if (jQuery(this).hasClass('right')){
			postId = jQuery('#previous-news').val();
		}else {return;}
		
		if (postId !=0){
			load_news(postId);
		}
	})
	
	function load_news(news){
		
		if (!news){news=0;}
		
		jQuery('.news-home-loading').fadeIn();
		
		var data = {
			action: 'news_load_recent',
			id: news,
			nonce: ajax_object.nonce_news_load_recent, 
		};
		
		$.get(ajax_object.ajaxurl, data, function(res, textStatus, jqXHR) {


			jQuery('.news-date').fadeOut(function(){jQuery(this).text(res.data.date);}).fadeIn();
			jQuery('.news-title').fadeOut(function(){jQuery(this).text(res.data.title);}).fadeIn();
			jQuery('.news-excerpt').fadeOut(function(){jQuery(this).text(res.data.excerpt);}).fadeIn();
			jQuery('.news-read-more a').fadeOut(function(){jQuery(this).attr('href',res.data.link);}).fadeIn();
			jQuery('.news-feature-image').fadeOut(function(){jQuery(this).attr('style','background-image:url('+res.data.img_url+')');}).fadeIn();
			jQuery('#next-news').fadeOut(function(){jQuery(this).val(res.data.next_id);}).fadeIn();
			jQuery('#previous-news').fadeOut(function(){jQuery(this).val(res.data.prev_id);update_links();}).fadeIn();	
			
			jQuery('.news-home-loading').fadeOut();
		},'json')
		
	}
	
	function update_links(){
		
		jQuery('#next-news')
		if (jQuery('#next-news').val() == 0){
			jQuery('.news_links.left').addClass('disabled');
		}else{
			jQuery('.news_links.left').removeClass('disabled');
		}
			
		if (jQuery('#previous-news').val() == 0){
			jQuery('.news_links.right').addClass('disabled');
		}else{
			jQuery('.news_links.right').removeClass('disabled');
		}
	}
	
	//Init actions
	update_links();
	
}(jQuery));


jQuery(document).ready(function(){
	if(jQuery('.news-actions').length >= 1){
		document._newsManager = new NewsManager();
		document._newsManager.initialize();
	}
});

function NewsManager(){

	
	this._currentPageIdx;
	this._order;
	
	this.initialize = function initialize(){
		this._currentPageIdx=1;
		jQuery('.sort-actions-select').change({manager: this}, this.loadNews);
		jQuery('.sort-actions-select').change({manager: this}, this.loadNews);
		jQuery('.load-more-action').click({manager: this}, this.loadNews);
		
		jQuery('.search-actions-button').click({'manager':this},function(e){e.data.manager.reLoadNews();});
		jQuery('.search-clear-actions-button').click({'manager':this},function(e){jQuery(".search-actions-input").val('');e.data.manager.reLoadNews();});
		jQuery('.search-clear-actions-button').hide();		
	}
	
	this.loadNews =  function(e, manager){
		
		ajax_object.query.post_type = "post";
		
		if (e){
			if (!manager){manager=e.data.manager;}
		}else{
			manager = this;
		}
		
		var data = {
			action: 'news_get',
			page: manager._currentPageIdx + 1,
			order: manager._order,
			query: ajax_object.query,
			nonce: ajax_object.nonce_news_load_recent,
		};
		
		/*handle search keyword*/
		if (jQuery(".search-actions-input").val()!=''){
			data['s']=jQuery(".search-actions-input").val();
			jQuery('.search-clear-actions-button').show();
		}else{
			jQuery('.search-clear-actions-button').hide();
		}		
		
		jQuery(".news-loading").show();
		
		jQuery.get({	url:ajax_object.ajaxurl, 
				data:data,
				context: manager,
				success: function(res) {
		
					if( res.success ){
						this.addNewsToList(res.data['list']);

						if (res.data['last_page']==true){
							this._lastPageLoaded=true;
							jQuery('.news-load-more').hide();
						}else{
							this._lastPageLoaded=false;
							jQuery('.news-load-more').show();
						}
						this._currentPageIdx++;
						/*If curentPage is less or equal to 1 it means that first page have been loaded, so slideDown*/
						if(this._currentPageIdx<=1){
							jQuery('.news-loop').slideDown();
						}
					}
					jQuery(".news-loading").hide();
					
				},
				error: function(xhr, textStatus, e) {
					// console.log(xhr.responseText);
					jQuery(".news-loading").hide();
					}
				});
	}
	

	this.resetLoad = function(){
		this.removeNewsFromList();
		this._currentPageIdx=0;		
		this._order = jQuery('.sort-actions-select').val();
		this._lastPageLoaded = false;
	}
	
	this.reLoadNews = function(){
		var that = this;
		jQuery('.news-loop').slideUp(400,
			function()
			{
				that.resetLoad();
				that.loadNews();
			});
		
	}	
	
	this.addNewsToList = function addNewsToList(data){
		jQuery(".news-loop").append(data);
	}
	
	this.removeNewsFromList = function removeNewsFromList(){
		jQuery(".news-loop").empty();
	}
	
}

/*
 * 
 * Accessibility triggering
 * 
 * */

(function() {

	function resizeText(multiplier) {
		  if (document.documentElement.style.fontSize == "") {
		    document.documentElement.style.fontSize = "1.0em";
		  }
		  
		  if (multiplier !=0){
			  document.documentElement.style.fontSize = parseFloat(document.documentElement.style.fontSize) + (multiplier * 0.2) + "em";
		  }else{
			  document.documentElement.style.fontSize = "1.0em";
		  }
		}
	
jQuery(".increase-size").click(function(){
	resizeText(1);
});

jQuery(".decrease-size").click(function(){
	resizeText(-1);
});

jQuery(".reset-size").click(function(){
	resizeText(0);
});

	
}());

/*
 * 
 * Agenda triggering
 * 
 */
(function() {
	
	var selected;
	
jQuery(".tribe-events-single-event-details").hide();

function select(postRootNode){
	var postSummary = jQuery(postRootNode).find(".tribe-events-single-event-summary");	
	var postDetails = jQuery(postRootNode).find(".tribe-events-single-event-details");
	postDetails.slideDown();
	
	postSummary.fadeTo(0.4, 1);
	jQuery(".tribe-events-single-event-details").not(postDetails[0]).slideUp();
	jQuery(".tribe-events-single-event-summary").not(postSummary[0]).fadeTo(0.4, 0.5);
	selected = postRootNode;
}

function unSelect(){
	jQuery(".tribe-events-single-event-details").slideUp();
	jQuery(".tribe-events-single-event-summary").fadeTo(0.4, 1);
	selected = undefined;
}

jQuery(".tribe-events-read-more").click(function(){
	
	var postRootNode = jQuery(this).parentsUntil(".tribe-events-loop")[jQuery(this).parentsUntil(".tribe-events-loop").length-1];
	
	if (selected){
		if (selected == postRootNode){
			unSelect();
			selected = undefined;
		}else{
			select(postRootNode);
			selected = postRootNode;
		}
	}else{
		select(postRootNode);
		selected = postRootNode;
	}
});

}());

/*
 * 
 * Map triggering
 * 
 */
(function($){
    window.addEventListener("DOMContentLoaded", function(event){
    	if ($('#map-preview').length > 0 && $('#map-modal').length > 0){
    		
    		$('#map-modal').on("shown.bs.modal", function(){
				mapsManager.getMapElt(mapsManager.getMapsId()[0].id).invalidateSize();
			});
    		
    		$('#map-preview').click(function(){
    			$('#map-modal').modal('show');
    		});
    	}
      });
})(jQuery);